import { render } from "./UrlCardCopy.vue?vue&type=template&id=451d496f&scoped=true"
import script from "./UrlCardCopy.vue?vue&type=script&lang=js"
export * from "./UrlCardCopy.vue?vue&type=script&lang=js"

import "./UrlCardCopy.vue?vue&type=style&index=0&id=451d496f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451d496f"],['__file',"src/scripts/common/components/UrlCardCopy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "451d496f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('451d496f', __exports__)) {
    api.reload('451d496f', __exports__)
  }
  
  module.hot.accept("./UrlCardCopy.vue?vue&type=template&id=451d496f&scoped=true", () => {
    api.rerender('451d496f', render)
  })

}


export default __exports__